import Vue from 'vue'
import Vuex from 'vuex'
import menus from "./modules/menus";

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
    token: '',
    userId: '',
    username: ''
	},
	mutations: {
    setToken: (state, token) => {
			state.token = token
			localStorage.setItem("token", token)
		},

    setUserId: (state, userId) => {
      state.userId = userId
      localStorage.setItem("userId", userId)
    },

    setUsername: (state, username) => {
      state.username = username
      localStorage.setItem("username", username)
    }
	},
	actions: {},
	modules: {
		menus
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js